<div
    class="notification-bar"
    [ngClass]="'notification-bar--' + type"
    [class.notification-bar--invert]="invert"
    [class.notification-bar--vertical]="vertical"
>
    <nw-icon class="notification-bar__icon" [icon]="icon"></nw-icon>
    <div class="notification-bar__header">
        <ng-content select="[notification-bar-header]"></ng-content>
    </div>
    <div class="notification-bar__body">
        <ng-content select="[notification-bar-body]"></ng-content>
    </div>
</div>
